/**
 * @file 修改密码弹窗组件
 */
<template>
  <div class="c-password--modal">
    <plv-dialog
      content-style="overflow: hidden;"
      :visible="visible"
      title="修改密码"
      show-footer-btn
      :closable="false"
      :close-on-click-mask="false"
      @confirm="handleSubmit"
      @cancel="handleClose"
      @close="handleClose"
    >
      <plv-form
        ref="form"
        :rules="rules"
        :model="form"
        label-width="120px"
      >
        <plv-form-item label="新密码" prop="password">
          <plv-input
            v-model="form.password"
            size="medium"
            type="password"
            autocomplete="new-password"
            placeholder="请输入新密码"
          />
        </plv-form-item>
        <plv-form-item label="确认新密码" prop="confirmPassword">
          <plv-input
            v-model="form.confirmPassword"
            size="medium"
            type="password"
            autocomplete="new-password"
            placeholder="再次输入新密码"
          />
        </plv-form-item>
      </plv-form>
    </plv-dialog>
  </div>
</template>

<script>
import { defaultFormRules } from '@/utils/type';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      form: {
        password: '',
        confirmPassword: ''
      },
      rules: Object.assign({
        confirmPassword: {
          validator: (rule, value, callback) => {
            if (value !== this.form.password) {
              callback(new Error('两次密码输入不一致'));
            }
            callback();
          }
        }
      }, defaultFormRules)
    };
  },
  methods: {
    async handleSubmit() {
      try {
        await this.$refs.form.validate();
        this.$emit('resetPassword', this.form);
        this.$emit('update:visible', false);
      } catch {}

    },
    handleClose() {
      this.$emit('update:visible', false);
    }
  }
};
</script>
